<template>
  <iframe
    class="h-full w-full"
    title="dynamicSlide"
    type="text/html"
    :src="url"
    frameborder="0"
    :class="{ 'pointer-events-none': isAutoPlaying }"
    @load="$emit('slide-ready', true)"
    @error="$emit('slide-ready', true)"
  />
</template>

<script lang="ts" setup>
defineProps({
  url: {
    type: String,
    required: true,
  },
  isAutoPlaying: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['slide-ready'])
</script>
